export default __webpack_public_path__ + "ed1f59f8ab284f57e43df4149fb453a8.svg";